// @ts-ignore re-exported from @theme-ui/components.
export { Box as default } from 'theme-ui';
//# sourceMappingURL=View.js.map